import React from 'react';

import { createComponent } from '@lit/react';

const MdOutlinedTextField = customElements.get("md-outlined-text-field");

export default createComponent({

    tagName: 'md-outlined-text-field',

    elementClass: MdOutlinedTextField!,

    react: React,

    events: {

    },

});